(ns client-portal.client.voice-commerce.charts.data
  "Chart data keyed by the `chart-id` a card is configured with, loaded from the
   voice-commerce charts endpoint — the same arrangement the Voice Insights charts
   use, so a card only has to name the chart it wants."
  (:require [cljs-time.core :as t]
            [cljs-time.format :as t.f]
            [clojure.string :as s]
            [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-commerce.orders.data :as orders.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(defn fill-bucket-gaps
  "Rows for every bucket between the first and the last, zero-filled where the query
   returned nothing. Without them a quiet hour reads as a straight line between the
   points either side rather than as a drop to zero. The bucket size comes from the
   rows themselves — hourly ones carry a time, daily ones don't."
  [rows]
  (let [rows (sort-by #(get % "dt") rows)
        first-dt (str (get (first rows) "dt"))]
    (if (< (count rows) 2)
      (vec rows)
      (let [hourly? (s/includes? first-dt "T")
            formatter (t.f/formatters (if hourly? :date-hour-minute-second :date))
            step (if hourly? (t/hours 1) (t/days 1))
            zero-row (into {} (map (fn [k] [k 0])) (remove #{"dt"} (keys (first rows))))
            by-dt (into {} (map (juxt #(get % "dt") identity)) rows)
            end (t.f/parse formatter (str (get (last rows) "dt")))]
        (loop [bucket (t.f/parse formatter first-dt)
               filled []]
          (if (t/after? bucket end)
            filled
            (let [dt (t.f/unparse formatter bucket)]
              (recur (t/plus bucket step)
                     (conj filled (or (get by-dt dt)
                                      (assoc zero-row "dt" dt)))))))))))

(def root-path [:voice-commerce :charts])
(def data-by-chart-id-path (conj root-path :data :by-chart-id))

(re/reg-auth0-loader
  :voice-commerce/load-chart-data
  (fn [[[_ chart-id]]]
    (conj data-by-chart-id-path chart-id))
  (fn [db [_ chart-id]]
    (when (and chart-id (concepts.d/current-concept-id db))
      {:method :post
       :url "/api/voice-commerce/charts/by-id"
       :json-params (assoc (orders.d/base-query-args db {}) :chart-id chart-id)}))
  ;; The body is a JSON string keyed by chart id — parsed here rather than by the
  ;; middleware so the column names the card references keep their exact casing.
  :transf (fn [resp]
            (or (some-> resp
                        :body
                        (util/json-string->map-basic)
                        (first)
                        (second))
                []))
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :voice-commerce/chart-data-
  (fn [_ chart-id]
    (conj data-by-chart-id-path chart-id))
  :voice-commerce/load-chart-data)

(re/reg-event-db
  :voice-commerce/chart-clear-data re/middleware
  (fn [db [chart-id]]
    (assoc-in db (conj data-by-chart-id-path chart-id) nil)))

(re/reg-event-fx
  :voice-commerce/chart-initialize-listener re/middleware
  (fn [_ [chart-id clear-data?]]
    (when clear-data?
      (re/dispatch [:voice-commerce/chart-clear-data chart-id]))
    {:forward-events {:register (keyword "voice-commerce-charts-initialization-listener-" chart-id)
                      :events #{:concepts/select :locations/select :locations/clear-selected
                                :core/select-timeframe :core/timeframe-date-range-changed}
                      :dispatch-to [:voice-commerce/chart-clear-data chart-id]}}))
